var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 15,
  fill: "none",
  viewBox: "0 0 17 15",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.795.853 5.25 10.067 2.715 7.36c-.466-.44-1.2-.467-1.733-.093-.52.386-.667 1.066-.347 1.613l3 4.88c.294.453.8.733 1.374.733a1.63 1.63 0 0 0 1.36-.733c.48-.627 9.64-11.547 9.64-11.547 1.2-1.226-.254-2.306-1.214-1.373z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkDefault.4fcb4770a892519171529c85e28074ed.svg";